import React from 'react'
import { StyledHighclassLp } from './styled'
import { Head } from 'spa/config/Head'

const Index: React.FC = () => {
  const title = 'クラウドワークス テック ハイクラス 202505'
  const description = '上級エンジニア、PM、PMO、ITコンサル、DXコンサル、戦略コンサルの場合、月額報酬上位30%の案件を優先的にご紹介します'

  return (
    <>
      <Head title={title} description={description} />
      <StyledHighclassLp />
    </>
  )
}

export default Index
